import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../../../Context/ProductDetailContext.js';
import { useLensBundle } from '../../../../LensBundles/context.js';
import Prescription from './Prescription.js';

const PrescriptionContainer = (props)=>{
    const { clAndSolutionsMaxOrderableQuantity: maxOrderableQuantity  } = useProductDetailContext();
    const { isContactLensStockEnabled  } = useFeatureToggles();
    const { hasCLBBSubscriptions , attributes: { actions  } ,  } = useLensBundle();
    // Use void function to scope logic to only lens bundle enabled products
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleLensBundleChange = hasCLBBSubscriptions ? actions.setAttribute : ()=>{};
    // Preliminary sorting of selected packSize
    const products = React.useMemo(()=>props.products.filter((product)=>product.attributes.packageQuantity === props.packSize
        )
    , [
        props.products,
        props.packSize
    ]);
    return /*#__PURE__*/ React.createElement(Prescription, swcHelpers.extends({}, props, {
        isStockEnabled: isContactLensStockEnabled,
        products: products,
        handleLensBundleChange: handleLensBundleChange,
        maxOrderableQuantity: maxOrderableQuantity
    }));
};

export { PrescriptionContainer as default };
//# sourceMappingURL=PrescriptionContainer.js.map
